export interface FlowGroupDto {
  flowGroupNumber: string;
  flowType: FlowType;
  bonusCurrency: BonusCurrency;
  periodStartType: PeriodStartType;
  periodStartValue?: string;
  periodDuration?: string;
  periodDurationUnit?: PeriodDurationUnit;
  flowDetails: FlowDetailsDto[];
  negativeAllowed: boolean;
  carryOver: boolean;
  expirationMode: ExpirationMode;
}

export interface FlowDetailsDto {
  flowDetailNumber?: string;
  threshold: string;
  flowDirection: FlowDirection;
  origin?: string;
  target?: string;
  immediate?: boolean;
  informStatusChange?: boolean;
  informUpcomingStatusChange?: boolean;
  thresholdReachedToInform?: string;
  monthsAdvanceToInform?: string;
}

export enum PeriodStartType {
  START_OF_YEAR = "START_OF_YEAR",
  FIXED_DATE = "FIXED_DATE",
  FIRST_PAYMENT_INTERACTION = "FIRST_PAYMENT_INTERACTION",
  REGISTRATION_DATE = "REGISTRATION_DATE",
}

export const getPeriodStartOptions = (t: (key: string) => string) => [
  { value: PeriodStartType.START_OF_YEAR, label: t("flow.startOfTheYear") },
  { value: PeriodStartType.FIXED_DATE, label: t("flow.fixedDate") },
  { value: PeriodStartType.FIRST_PAYMENT_INTERACTION, label: t("flow.firstPurchase") },
  { value: PeriodStartType.REGISTRATION_DATE, label: t("flow.dateOfRegistration") },
];

export enum PeriodDurationUnit {
  MONTH = "MONTH",
  YEAR = "YEAR",
}

export const getPeriodDurationUnitOptions = (t: (key: string) => string) => [
  { value: PeriodDurationUnit.MONTH, label: t("flow.month") },
  { value: PeriodDurationUnit.YEAR, label: t("flow.year") },
];

export enum FlowType {
  CIRCLE = "CIRCLE",
  IDENTIFICATION = "IDENTIFICATION",
  BONUS_PREMIUM = "BONUS_PREMIUM",
}

export enum FlowTypeTrans {
  CIRCLE = "Circle",
  IDENTIFICATION = "Wallet",
  BONUS_PREMIUM = "BONUS_PREMIUM",
}

export const flowTypeOptions = [
  { value: FlowType.CIRCLE, label: "Circle" },
  { value: FlowType.IDENTIFICATION, label: "Wallet" },
  { value: FlowType.BONUS_PREMIUM, label: "Bonusprämie" },
];

export enum BonusCurrency {
  BONUS_POINT = "BONUS_POINT",
  REWARD_POINT = "REWARD_POINT",
  PAYMENT_AMOUNT = "PAYMENT_AMOUNT",
}

export const getBonusCurrencyOptions = (t: (key: string) => string) => [
  { value: BonusCurrency.BONUS_POINT, label: t("flow.bonusPoints") },
  { value: BonusCurrency.REWARD_POINT, label: t("flow.rewardPoints") },
  { value: BonusCurrency.PAYMENT_AMOUNT, label: t("flow.euroRevenue") },
];

export enum FlowDirection {
  UPGRADE = "UPGRADE",
  DOWNGRADE = "DOWNGRADE",
}

export enum FlowDirectionTrans {
  UPGRADE = "Aufstufen",
  DOWNGRADE = "Herabstufen",
}

export const getFlowDirectionOptions = (t: (key: string) => string) => [
  { value: FlowDirection.UPGRADE, label: t("flow.upgrade") },
  { value: FlowDirection.DOWNGRADE, label: t("flow.downgrade") },
];

export const flowDirectionOptions = [
  { value: FlowDirection.UPGRADE, label: "überschritten" },
  { value: FlowDirection.DOWNGRADE, label: "unterschritten" },
];

export enum ExpirationMode {
  FIXED_INTERVAL = "FIXED_INTERVAL",
  NO_EXPIRATION = "NO_EXPIRATION"
}

export const getExpirationModeOptions = (t: (key: string) => string) => [
  { 
    value: ExpirationMode.FIXED_INTERVAL, 
    label: t("flow.fixedInterval"),
    description: t("flow.fixedIntervalDescription")
  },
  { 
    value: ExpirationMode.NO_EXPIRATION, 
    label: t("flow.noExpiration"),
    description: t("flow.noExpirationDescription")
  },
];
